export const FUNDING_APP_BASE_URL = () => {
  return process.env.REACT_APP_FUNDING_APP_BASE_URL;
};

export const ORIGINATIONS_APP_BASE_URL = () => {
  return process.env.REACT_APP_UNDERWRITING_APP_BASE_URL;
};

export const WAITING_ROOM_BASE_URL = () => {
  return process.env.REACT_APP_WAITING_ROOM_BASE_URL;
};

export const UNDERWRITING_BASE_URL = () => {
  return process.env.REACT_APP_UNDERWRITING_BASE_URL;
};

export const PARTNER_API_BASE_URL = () => {
  return process.env.REACT_APP_PARTNER_API_BASE_URL;
};

export const MIXPANEL_API_TOKEN = () => {
  return process.env.REACT_APP_MIXPANEL_API_TOKEN;
};

export const DATADOG_RUM_APPLICATION_ID = () => {
  return process.env.REACT_APP_DATADOG_RUM_APPLICATION_ID;
};

export const DATADOG_RUM_CLIENT_TOKEN = () => {
  return process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN;
};

export const DATADOG_SITE = () => {
  return process.env.REACT_APP_DATADOG_SITE;
};

export const DEPLOY_ENV = () => {
  return process.env.REACT_APP_DEPLOY_ENV;
};

export const APP_VERSION = () => {
  return process.env.REACT_APP_VERSION;
};

export const SOURCES = {
  STANDARD: "standard_form",
  SHORT: "shortened_form",
  RENEWAL: "renewal_form",
};
